// extracted by mini-css-extract-plugin
export default {"element":"ingredient_element__I-O81","price":"ingredient_price__jpZ+1","title":"ingredient_title__eyOmN","link":"ingredient_link__2GCv4"};